// One health authority for the whole app. Individual API failures are not
// proof of an outage, and liveness/degraded HTTP200 is not proof of recovery.
export function createBackendAvailability({ probe, onDown, onUp, now = Date.now,
  schedule = (fn, ms) => setTimeout(fn, ms), cancel = clearTimeout }) {
  let down = false, firstFailure = 0, failures = 0, readyStreak = 0, firstReady = 0;
  let running = null, timer = null, lastProbe = -Infinity, disposed = false;
  const resetFailures = () => { failures = 0; firstFailure = 0; };
  const retry = () => {
    if (running) return running;
    if (timer) { cancel(timer); timer = null; }
    lastProbe = now();
    running = Promise.resolve().then(probe).then(ready => {
      if (disposed) return;
      if (ready) {
        resetFailures();
        if (down) {
          if (!readyStreak) { readyStreak = 1; firstReady = now(); }
          else if (now() - firstReady >= 4000) { down = false; readyStreak = 0; onUp(); }
        }
      } else {
        readyStreak = 0;
        if (!down) { down = true; onDown(); }
      }
    }).catch(() => {
      if (!disposed) {
        readyStreak = 0;
        if (!down) { down = true; onDown(); }
      }
    }).finally(() => {
      running = null;
      if (down && !disposed) timer = schedule(retry, 5000);
    });
    return running;
  };
  return {
    isDown: () => down,
    failure() {
      if (down || disposed) return;
      if (!failures) firstFailure = now();
      failures++;
      if (failures >= 5 && now() - firstFailure >= 2000 && now() - lastProbe >= 10000) retry();
    },
    success() { if (!down) resetFailures(); },
    retry,
    dispose() { disposed = true; if (timer) cancel(timer); },
  };
}